// Ported RNN modules
// @TODO: Refactor the modules listed to remove jquery and simplify logic
//
// @TODO: This module serves primarily as a midpoint for porting old functionality
// we rely on from the legacy modules to the new code JS codebase. Once the work
// around this settles down it's primary purpose then shifts to being a core module
// used between BSS/MYT and providing public functions to reduce template js logic.
//
// @NOTE: Maybe during that refactor we should rename this module to finda to signal
// the api changeover and the new (To be fully worked out) pattern for calling into
// webpack contained javascript
import B64 from './rnn/B64'
import ItemCarousel from './rnn/ItemCarousel' // @TODO Refactor
import Maps from './rnn/Maps' // @TODO Refactor
import User from './rnn/User'
import GoogleAnalytics from './rnn/GoogleAnalytics'
import GoogleAnalyticsTracking from './rnn/GoogleAnalyticsTracking'
import Omniture from './rnn/Omnitrue'
import AdminUI from './rnn/AdminUI'
import Facebook from './rnn/Facebook' // @TODO Refactor
import Galleries from './rnn/Galleries'

// Ported Styles
import '../styles/rnn.scss'

// RNN init() - The main entry point for rnn modules ported over from
// the legacy JS codebase. This module will typically be imported and loaded
// onto `window.rnn`.
//
// @TODO Parse/validate siteconfig, write it in TS for typings
// and handle siteconfig as a seperate module that can be imported
export function init(siteConfig){

  // Update the global site object
  window.rnn.site = siteConfig

  // Initialise the "Core" Modules which provide exported objects at
  // `rnn.modules` to support external function calls
  User.init(siteConfig)
  GoogleAnalytics.init(siteConfig)
  GoogleAnalyticsTracking.init()
  Omniture.init()
  Facebook.init(siteConfig)
  AdminUI.init()
  Galleries.init()

  // @NOTE: We generally don't want to export modules as communication over the
  // `window` object as it is error prone at best. For modules that don't require JS
  // calls from inline template, just use ES6 import/export
  ItemCarousel()
  B64()
  Maps(siteConfig)

}

export default {
  init,
  site: {},
  modules: {
    user: User,
    g_analytics: GoogleAnalytics,
    trackFindaEvents: GoogleAnalyticsTracking,
    omniture: Omniture,
    facebook: Facebook,
    adminUI: AdminUI,
    galleries: Galleries,
  },
}
